/**
 * [state 状态]
 * userData 用户数据
 * 
 * [actions 事件派发]
 * SET_USERDATA 改变状态中的用户数据]
 * 
 * [mutations 状态变更]
 */
const storeData = {
  assetChange: JSON.parse(window.localStorage.getItem('assetChange')),
  assetRepair: JSON.parse(window.localStorage.getItem('assetRepair')),
  assetHandle: JSON.parse(window.localStorage.getItem('assetHandle')),
}

export default {
  state: {
    assetDetail: {
      status: false,
      data: {}
    },
    assetChangeDetail: {
      status: false,
      data: {}
    },
    assetRepairDetail: {
      status: false,
      data: {}
    },
    assetHandleDetail: {
      status: false,
      data: {}
    },

    assetChange: storeData.assetChange ? storeData.assetChange : {
      type: 0,
      data: []
    },
    assetRepair: storeData.assetRepair ? storeData.assetRepair : {
      type: 0,
      data: []
    },
    assetHandle: storeData.assetHandle ? storeData.assetHandle : {
      type: 0,
      data: []
    },
  },
  mutations: {
    set_assetDetail(state, val) {
      state.assetDetail = val
    },
    set_assetChangeDetail(state, val) {
      state.assetChangeDetail = val
    },
    set_assetRepairDetail(state, val) {
      state.assetRepairDetail = val
    },
    set_assetHandleDetail(state, val) {
      state.assetHandleDetail = val
    },
    set_assetChange(state, val) {
      if (val) {
        window.localStorage.setItem('assetChange', JSON.stringify(val))
      } else {
        window.localStorage.removeItem('assetChange')
      }
      state.assetChange = val
    },
    set_assetRepair(state, val) {
      if (val) {
        window.localStorage.setItem('assetRepair', JSON.stringify(val))
      } else {
        window.localStorage.removeItem('assetRepair')
      }
      state.assetRepair = val
    },
    set_assetHandle(state, val) {
      if (val) {
        window.localStorage.setItem('assetHandle', JSON.stringify(val))
      } else {
        window.localStorage.removeItem('assetHandle')
      }
      state.assetHandle = val
    },
  },
  actions: {}
}


// WEBPACK FOOTER //
// ./src/store/asset.js